import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  wrapper: {
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    padding: '16px',
    margin: '12px 0',
    textAlign: 'center',
  },
  title: {
    fontWeight: 700,
    color: '#1A1A1A',
    marginBottom: '10px',
  },
}));

// Mostrado enquanto awaiting_incentive_tickets: o pedido completou mas os
// bilhetes de incentivo (e portanto o painel de jogos) ainda estão sendo
// gerados no backend. Ocupa a posição do OrderGamePanel pra evitar o painel
// "aparecer do nada" e o layout pular quando o poll virar.
export default function OrderGamePanelSkeleton() {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Typography variant="body1" component="div" className={classes.title}>
        Preparando seus jogos…
      </Typography>
      <Skeleton variant="rect" width="100%" height={120} style={{ borderRadius: '8px' }} />
    </div>
  );
}
